import {Injectable} from '@angular/core';
import {GfxHttpSrv} from '../../../services/GfxHttpSrv';
import {Observable} from 'rxjs';
import {Router} from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class LoginService {

    constructor(private gfxHttp: GfxHttpSrv,
                private router: Router) {
    }

    checkAssure(matricule: string, dateNaissance: string): Observable<any> {
        return this.gfxHttp.get('portal/assure/phone', {
            matricule: matricule,
            dateNaissance: dateNaissance
        });
    }

    verifAndSendCodeSMS(data) {
        return this.gfxHttp
            .post('portal/assure/verif-and-send-sms', data);
    }

    codeVerification(data) {
        return this.gfxHttp
            .post('portal/assure/code-verification', data);
    }

    resendCode(matricule) {
        return this.gfxHttp.get('portal/assure/resend-code', {matricule: matricule});
    }
}
